<template>
  <div class="main-simule-aqui">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="simule-aqui">
            <loading
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-page="true"
              class="overlay-load"
              :z-index="9999"
            >
            </loading>

            <transition name="fade" mode="out-in">
              <div id="step-4" class="multi-step-form active-step">
                <div class="align-flex-title">
                  <h3>Seus dependentes</h3>
                </div>
                <div
                  class="row"
                  v-if="incluirDependente"
                  style="display: block; margin-top: 24px"
                >
                  <div class="add-gerenciar-dep">
                    <b-button
                      style="width: 100%; margin: 0"
                      @click="adicionarDependente()"
                    >
                      <img
                        style="margin-top: -5px; margin-right: 5px"
                        src="@/assets/add-dependente-rounded.svg"
                      />
                      Adicionar dependente
                    </b-button>
                  </div>
                  <div
                    class="dep-div"
                    v-for="(dependente, i) in dependentes"
                    :key="i"
                    style="margin: 0"
                  >
                    <b-button
                      class="toggle-dependente-mostrar"
                      v-b-toggle="'dep-collapse-' + i"
                    >
                      <div class="identificacao-dep">
                        <img
                          style="margin-top: -5px; margin-right: 25px"
                          src="@/assets/user-add-dependente.svg"
                        />
                        <span>{{
                          dependente.NomeDep != ""
                            ? dependente.NomeDep
                            : "Dependente " + (i + 1)
                        }}</span>
                      </div>
                      <div class="botao-aux">
                        <img
                          v-if="controledep[i]"
                          style="margin-top: 18px"
                          src="@/assets/arrow-up.svg"
                        />
                        <img
                          v-else
                          style="margin-top: 18px"
                          src="@/assets/arrow-down.svg"
                        />
                      </div>
                    </b-button>
                    <b-collapse
                      :id="'dep-collapse-' + i"
                      v-model="controledep[i]"
                      class="container toggle-dependente-unidade"
                    >
                      <div
                        style="
                          display: block;
                          text-align: left;
                          margin-top: 50px;
                        "
                      >
                        <p>Nome do dependente:</p>
                        <b-form-input
                          @keydown="onlyLetters($event)"
                          :formatter="formatter"
                          v-model="dependente.NomeDep"
                          placeholder="Digite o nome do dependente"
                          :class="{
                            'statusok-fontbold':
                              dependente.NomeDep.length > 2 &&
                              dependente.NomeDep.indexOf(' ') > 0,
                          }"
                        ></b-form-input>
                        <img
                          v-if="
                            dependente.NomeDep.length > 2 &&
                            dependente.NomeDep.indexOf(' ') > 0
                          "
                          class="statusok-check"
                          src="@/assets/statusok.svg"
                          alt="Check"
                        />
                      </div>
                      <div class="row" style="display: flex">
                        <div
                          class="input-field-simulador col-sm-6"
                          style="display: block; text-align: left"
                        >
                          <p>Grau de parentesco:</p>
                          <b-form-select
                            v-model="dependente.GrauParentescoDep"
                            :options="options_grauparentesco"
                            :class="{
                              'statusok-fontbold':
                                dependente.GrauParentescoDep != null,
                            }"
                            :style="[
                              dependente.GrauParentescoDep != null
                                ? {
                                    background:
                                      'url(' +
                                      require('@/assets/statusok.svg') +
                                      ') no-repeat right 2.6% center #ffffff',
                                  }
                                : '',
                            ]"
                          >
                            <b-form-select-option :value="null">
                              Selecione aqui
                            </b-form-select-option>
                          </b-form-select>
                        </div>
                        <div
                          class="input-field-simulador col-sm-6"
                          style="display: block; text-align: left"
                        >
                          <p>Data de nascimento:</p>
                          <div class="date-picker-add-dep">
                            <date-picker
                              v-model="dependente.DataNascDep"
                              v-mask="'##/##/####'"
                              valueType="format"
                              format="DD/MM/YYYY"
                              placeholder="Informe a data de nascimento do dependente"
                              :editable="true"
                              input-class="form-control"
                              :class="{
                                'statusok-fontbold-datepicker':
                                  dependente.DataNascDep.length > 9,
                              }"
                              @change="habilitaDependentes()"
                              :disabled-date="
                                (date) => (date > new Date() ? true : false)
                              "
                            ></date-picker>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="tipoorgaoentidade == 'orgao'"
                        class="input-field-simulador"
                        style="display: block; text-align: left"
                      >
                        <p>Faixa de remuneração do dependente:</p>
                        <b-form-select
                          v-model="dependente.FaixaRemuneracaoDep"
                          :options="options_faixaremuneracao"
                          :class="{
                            'statusok-fontbold':
                              dependente.FaixaRemuneracaoDep != null,
                          }"
                          :style="[
                            dependente.FaixaRemuneracaoDep != null
                              ? {
                                  background:
                                    'url(' +
                                    require('@/assets/statusok.svg') +
                                    ') no-repeat right 2.6% center #ffffff',
                                }
                              : '',
                          ]"
                        >
                          <b-form-select-option :value="null"
                            >Selecione aqui</b-form-select-option
                          >
                        </b-form-select>
                      </div>
                    </b-collapse>
                    <b-button
                      class="toggle-dependente-excluir"
                      @click="removerDependenteLista(i)"
                    >
                      <img
                        style="margin-top: -5px; margin-right: 5px"
                        src="@/assets/remover-dependente-rounded.svg"
                      />
                      <span>Remover dependente</span>
                    </b-button>
                  </div>
                  <!-- TESTE VALIDAÇÃO -->
                  <div v-if="errors.length">
                    <b v-for="erro in errors" :key="erro">{{ erro }}</b>
                  </div>
                  <!-- TESTE VALIDAÇÃO -->
                </div>
                <div
                  class="row finaliza-dep"
                  style="
                    margin-top: 100px;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <div v-if="dependentesDiferentes" @click="setEtapa('PD')">
                    <b-button
                      class="
                        btn-alianca
                        btn-next
                        btn-next-continuar-simule-nomargin
                        btn-clicked
                      "
                      >PESQUISAR PLANOS</b-button
                    >
                    <b-button
                      class="
                        btn-alianca btn-next btn-icon-next btn-clicked-icon
                      "
                      ><img
                        src="@/assets/procurar-planos.svg"
                        alt="Pesquisar planos"
                    /></b-button>
                  </div>
                  <span
                    @click="voltarPagina()"
                    style="
                      margin-top: 5px;
                      border-bottom: 1px solid black;
                      line-height: 25px;
                      cursor: pointer;
                    "
                    >Voltar</span
                  >
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import VueMask from "v-mask";
import store from "@/store";
import textFormatter from "@/utils/textFormatter.js"
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
Vue.use(VueMask);

export default {
  name: "Simule-aqui",
  mixins: [],
  components: {
    Loading,
  },
  data() {
    return {
      preenchido: false,
      errors: [],
      incluirDependente: true,
      originalDependentes: [],
      dependentes: [],
      finalizaprocesso: false,
      exibefinaliza: false,
      isLoading: false,
      tipoorgaoentidade: "",
      controledep: [],
      startwithdep: false,
    };
  },
  computed: {
    dependentesDiferentes() {
      if (this.dependentes.length !== this.originalDependentes.length) {
        return true
      }

      let diferencas = 0;

      this.dependentes.forEach((el, index) => {
        if (el.DataNascDep !== this.originalDependentes[index].DataNascDep) {
          diferencas++
        }
      })

      return diferencas
    },
    options_grauparentesco: {
      get() {
        return store.getters.getSimuleAquiGrauParentesco;
      },
      set(newVal) {
        store.commit("mutSimuleAquiGrauParentesco", newVal);
      },
    },
    options_faixaremuneracao: {
      get() {
        return store.getters.getSimuleAquiFaixaRemuneracao;
      },
      set(newVal) {
        store.commit("mutSimuleAquiFaixaRemuneracao", newVal);
      },
    },
  },
  methods: {
    formatter(val){
        return val.toUpperCase();
    },
    onlyLetters(e){
      textFormatter.onlyLetters(e);
    },
    voltarPagina() {
      this.$router.push({
        name: "Dados-beneficiario",
        params: { step: "step-7" },
      });
    },
    // Deveria estar no componente stepDois, mas tive alguns problemas com emit
    calculateAge(date) {
      let currentDate = new Date();
      let birthDate = new Date(date);
      let difference = currentDate - birthDate;
      let age = Math.floor(difference / 31557600000);
      return age;
    },
    habilitaDependentes() {
      this.finalizaprocesso = true;
      this.exibefinaliza = true;
    },
    adicionarDependente() {
      this.dependentes.push({
        NomeDep: "",
        CPFDep: "",
        GrauParentescoDep: null,
        DataNascDep: "",
        sexo: null,
        nomemae: "",
        estadocivil: null,
        documentoTipodep: null,
        documentoNumerodep: "",
        documentoOrgao: null,
        documentoUf: null,
        documentoDtExpedicao: "",
        certidaonascidovivo: "",
      });
      this.controledep.push(false);
      this.$root.$emit(
        "bv::toggle::collapse",
        "dep-collapse-" + (this.dependentes.length - 1)
      );
    },
    removerDependenteLista(i) {
      this.dependentes = this.dependentes.filter((el, index) => {
        if (index == i) {
          console.log("Removido: ", el);
          return false;
        }
        return true;
      });
      this.controledep = this.controledep.filter((el, index) => {
        if (index == i) {
          console.log("Removido: ", el);
          return false;
        }
        return true;
      });
    },
    validaStep4() {
      this.errors = [];

      if (this.dependentes.length) {
        let accerros = [0, 0, 0, 0, 0, 0];
        for (let i = 0; i < this.dependentes.length; i++) {
          if (!this.dependentes[i].NomeDep) accerros[0]++;
          // if (!this.dependentes[i].CPFDep) accerros[1]++
          if (!this.dependentes[i].GrauParentescoDep) accerros[2]++;
          if (
            this.dependentes[i].DataNascDep.length > 0 &&
            this.dependentes[i].DataNascDep.length.length < 8
          )
            accerros[3]++;
          if (!this.dependentes[i].DataNascDep) accerros[4]++;
          if (this.tipoorgaoentidade == "orgao") {
            if (!this.dependentes[i].FaixaRemuneracaoDep) accerros[5]++;
          }
        }

        if (accerros[0] > 0) {
          this.errors.push("Preencha o nome de todos os dependentes");
          return false;
        }
        /* if (accerros[1] > 0) {
            this.errors.push('Preencha o CPF de todos os dependentes');
            return false;
          } */
        if (accerros[2] > 0) {
          this.errors.push(
            "Selecione o grau de parentesco de todos dependentes"
          );
          return false;
        }
        if (accerros[3] > 0) {
          this.errors.push(
            "Data de nascimento de algum dos dependentes está incompleta"
          );
          return false;
        }
        if (accerros[4] > 0) {
          this.errors.push(
            "Preencha a data de nascimento de todos dependentes"
          );
          return false;
        }
        if (accerros[5] > 0) {
          this.errors.push(
            "Preencha a faixa de remuneração de todos dependentes"
          );
          return false;
        }

        /*
          if (ddlParentesco.SelectedValue == "13" && idade > DateTime.Parse(proposta.BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('A data de nascimento deve ser menor que a do titular.');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].ESTADO_CIVIL != "C"){
              this.errors.push('O estado civil do titular deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "11" && ((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS.FindAll(p => p.GRAU_PARENTESCO == "11").Count > 0){
              this.errors.push('Já existe um beneficiário com o grau parentesco cônjugue .');
          }
          if (ddlParentesco.SelectedValue == "11" && ddlEstadoCivil.SelectedValue.ToUpper() != "C"){
              this.errors.push('O estado civil deve ser casado .');
          }
          if (ddlParentesco.SelectedValue == "15" && idade > 18){
              this.errors.push('MENOR SOBRE GUARDA deve ter menos que 18 anos.');
          }
          if ((ddlParentesco.SelectedValue == "20" || ddlParentesco.SelectedValue == "16") && idade < DateTime.Parse(((PROPOSTA_MODELO)ViewState["PROPOSTA"]).BENEFICIARIOS[0].DATA_NASCIMENTO.FormataData()).retornaIdade()){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter idade maior que a do titular .');
          }
          if (ddlParentesco.SelectedValue == "17" && idade < 18){
              this.errors.push('" + ddlParentesco.SelectedItem.Text + " deve ter maior de 18 anos .');
          }
          */
      }

      return true;
    },
    async setEtapa(meta = "") {
      if (this.validaStep4()) {
        if (meta != "" && meta == "PD") {
          console.log(this.dependentes);
          store.commit("mutAliancaPossuiDep", "Sim");
          store.commit("mutAliancaObjDependentes", this.dependentes);
        } else {
          store.commit("mutAliancaPossuiDep", "Não");
          store.commit("mutAliancaObjDependentes", null);
        }

        store.commit("mutAliancaStatusAnalise", false);
        store.commit("mutAliancaSelectedPlano", null);
        store.commit("mutAliancaPlanosLista", []);
        store.commit("mutAliancaPlanosListaFormatadoDireto", []);
        store.dispatch("disAliancaPlanosFiltros");
        store.dispatch("disAliancaPlanosLista");
        this.$router.push("seu-plano");
      }
    },
  },
  async mounted() {
    this.originalDependentes = store.getters.getAliancaObjDependentes ? store.getters.getAliancaObjDependentes : this.originalDependentes;

    // criando deep copy do array acima
    this.dependentes = JSON.parse(JSON.stringify(this.originalDependentes));

    if (this.dependentes != null) {
      this.finalizaprocesso = true;
      this.startwithdep = true;
    } else {
      this.dependentes = [];
      this.startwithdep = false;
    }

    /* let funcpublico = store.getters.getAliancaFuncPub
    if (funcpublico != null){
      if (funcpublico == 'Sim'){
        this.tipoorgaoentidade = 'orgao'
      } else {
        this.tipoorgaoentidade = 'entidade'
      }
    }*/

    for (let i = 1; i <= 4; i++) {
      document
        .getElementById("globaletapam" + i)
        .classList.remove("etapas-progresso-mobile-show");
      document
        .getElementById("globaletapaprox" + i)
        .classList.remove("div-proximo-etapa-mobile-show");
    }

    document
      .getElementById("globaletapam1")
      .classList.add("etapas-progresso-mobile-show");
    document
      .getElementById("globaletapaprox1")
      .classList.add("div-proximo-etapa-mobile-show");

    document.getElementById("step-progress").value = 6.67 * 5;
    document
      .getElementById("step-progress-point1")
      .classList.add("rounded-point-progress-ok");
  },
};
</script>

<style scoped>
.add-gerenciar-dep {
  padding-bottom: 49px;
  margin-bottom: 48px;
  border-bottom: 1px solid #dbd4c2;
}

.date-picker-add-dep,
.mx-datepicker,
.mx-datepicker >>> div {
  margin: 0 !important;
}

.toggle-dependente-mostrar {
  width: 100%;
  height: 71px;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 6px 6px 0px 0px;
  margin-left: 0;
  display: flex;
  justify-content: space-between;
  padding-left: 18px;
  padding-right: 18px;
}

.toggle-dependente-mostrar > .identificacao-dep > span {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 30px;
  color: #a01d22;
}

.toggle-dependente-mostrar > .botao-aux {
  margin-top: 5px;
  width: 44px;
  height: 44px;
  background: #ede1c2;
  border-radius: 8px;
}

.toggle-dependente-unidade {
  width: 100%;
  margin: 0;
  background: #ffffff;
  border: 1px solid #bdbdbd;
  box-sizing: border-box;
  border-radius: 0px 0px 6px 6px;
  padding-left: 25px;
  padding-right: 25px;
}

.toggle-dependente-excluir {
  width: 100%;
  margin-left: 0;
  margin-top: 10px;
  height: 48px;
  background: #a01d22;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  border-radius: 6px;
  margin-left: -15px;
  margin-right: -15px;
}

.toggle-dependente-excluir:hover {
  background: #ffffff !important;
  border: 1px solid #a01d22 !important;
}

.toggle-dependente-excluir:hover > span {
  color: #a01d22;
}

.toggle-dependente-excluir > span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.1px;
  color: #ffffff;
}
</style>
